import React from "react"
import CustomTable from "../components/CustomTable";
import { enableDisableReportedSocialMediaPost, getAllPostOnReports } from "../services/ApiServices";
import { useDispatch, useSelector } from "react-redux";
import { ImageButton } from "../components/masterDataForm/ImageButton";
import { ReportButton } from "../components/ReportButton";
import SocailMediaImages from "../components/masterDataForm/SocailMediaImages";
import ReportedUserTable from "../components/ReportedUserTable";
import { EnableDisableBtn } from "../components/EnableDisableBtn";
import { toast } from "react-toastify";

const Report = () => {
    const [reportMediaImageShow, setReportMediaImageShow] = React.useState(false);
    const [showReportedTableDialog, setShowReportedTableDialog] = React.useState(false);
    const [reportMediaImage, setReportMediaImage] = React.useState([]);
    const [reportedUserData, setReportedUserData] = React.useState([]);



    const dispatch = useDispatch()
    const MediaPostReportInfo = useSelector(state => state?.getAllMediaPostReport.reports)
    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllPostOnReports();
                if(res.status === 200) {
                    dispatch({ type: 'GET_ALL_MEDIA_POST_REPORTS', payload: res.data.data })
                }
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    }, [dispatch]);


    const reportedMediaPostEnableAndDisable = async (postId) => {
        try {
            const enableDisableReportedStatus = await enableDisableReportedSocialMediaPost(postId);
            if(enableDisableReportedStatus.status === 200) {
                dispatch({ type: 'UPDATE_ENABLE_DISABLE_STATUS', payload: enableDisableReportedStatus.data?.data})
                toast.success(enableDisableReportedStatus.data?.message)
            }
        } catch (error) {
            toast.error('Something Wrong')
        }
    };

    const colDefs = [
        { field: "userId", flex: 1.2, headerName: 'Posted By', valueFormatter: (params) => params.value.firstName + " " + params.value.lastName},
        { field: "image", flex: 1, filter: false, headerName: 'Media Image', cellRenderer: (val) => <ImageButton images={val.data.image} setShowImageBtn={setReportMediaImageShow} setImages={setReportMediaImage} />},
        { field: "description", flex: 2, headerName: 'Media Description'  },
        { field: "reportedBy", flex: 1, headerName: 'Reported User Count', cellRenderer: (val) => <ReportButton userCount={val.data?.reportedBy.length} setReportedUserData={setReportedUserData} reportData={val.data?.reportedBy} setShowBtn={setShowReportedTableDialog} /> },
        { field: "createdAt", flex: 1, headerName: 'Date', valueFormatter: (params) => new Date(params.value).toISOString().split('T')[0]},
        { field: 'isDelete', filter: false, flex: 1.2, headerName: 'Action', cellRenderer: (val) => ( <EnableDisableBtn  status={val?.data?.isDelete}  statusId={val.data._id}  handleApprovedAndUnAprooved={reportedMediaPostEnableAndDisable} />) }
      ]


    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>REPORTED SOCIAL MEDIA POST</h3>
            </div>
            <CustomTable colDefs={colDefs} rowData={MediaPostReportInfo} />
            <SocailMediaImages name="Reported Social Media Images" showImageDialog={reportMediaImageShow} socialPostImage={reportMediaImage} setShowImageDialog={setReportMediaImageShow}  />
            <ReportedUserTable reportedUsers={reportedUserData} showReportedTableDialog={showReportedTableDialog} setShowReportedTableDialog={setShowReportedTableDialog}/>
        </React.Fragment>
    )
};
export default Report;